/* eslint no-undef: 0 */
import normalConfig from '../../../config/index';

const config = {
  ...normalConfig,
};

config.debugEnv = ['dev', 'beta'];
config.debugModel = process.env.VUE_APP_MODEL === 'local' ||
  config.debugEnv.indexOf(_ENV_ || process.env.VUE_APP_ENV);

config.host = '/';
const protocol = window.location.protocol;

config.rioHost = `${protocol}//${window.GLOBAL_VAR.url_host.rio_host}`;
config.adminPage = `${protocol}//${window.GLOBAL_VAR.url_host.admin_host}/`;
config.homePage = `${protocol}//${window.GLOBAL_VAR.url_host.site_host}/`;
config.gitlabHost = `${protocol}//${window.GLOBAL_VAR.url_host.git_host}`;

config.cgiRouter = 'cgi/';
config.cgiBinRouter = 'cgi-bin/';
config.govNode = 'govcloud-node/node/'; // Node 平台
config.cgiResource = 'resource-api/';
config.vendorAgencyRouter = 'vendor_agency/rio/';
config.vendorAgencyForReionRouter = 'vendor_agency/'; // 机构管理中涉及行政区划
config.apiRouter = {
  account: `${config.cgiRouter}account/v2`,
  menu: `${config.cgiRouter}privilege`,
  role: `${config.cgiRouter}privilege`,
  cgi: `${config.cgiRouter}appmgr`,
  jsnode: `${config.cgiRouter}jsnode`,
  wx3rd: `${config.cgiBinRouter}wx3rd`,
  abilities: `${config.cgiRouter}abilities`,
  doc: `static/doc`,
  flow: `${config.cgiRouter}console`,
  dataPublishSystem: `${config.govNode}datasource`,
  cloudPigeon: 'cloud-pigeon',
  zwopenRio: `${config.cgiRouter}rio`,
  system: `${config.cgiRouter}system`,
  mpmgr: `${config.cgiRouter}mpmgr`,
  bemgr: `${config.cgiRouter}bemgr`,
  devtool: `devtool`,
  itSelf: `${config.cgiRouter}it_selfservice`,
  cdn: `${config.cgiRouter}cdn_broker`,
  gitlab: `${config.cgiRouter}gitlab_broker`,
  content: `${config.cgiResource}`,
  rioOrganization: `${config.cgiRouter}${config.vendorAgencyRouter}ebus/omp/agency`,
  regionOrganization: `${config.cgiRouter}${config.vendorAgencyForReionRouter}`,
  rioVendor: `${config.cgiRouter}${config.vendorAgencyRouter}ebus/vmp/vendor`,
  rioAccount: `${config.cgiRouter}${config.vendorAgencyRouter}ebus/acc/account`,
  gdbsNav: `${config.cgiRouter}vendor_agency/gdbs/ebus/wtmhyy/mhyynode/gdbsNav/index`,
};

// rio登出
// config.login = '/_login';
config.logout = `/_tif_logout_/?url=%2F`;

// 当前系统存到localStorage的sid
config.lsSidName = `${config.homePage}sid`;
config.lsEntry = `${config.homePage}entry`;
config.lsEntryList = `${config.homePage}entryList`;
config.lsUser = `${config.homePage}user`;

// loading存在当前页面的超时时间
config.loadingTimeout = 15000;

if (config.debugModel) {
  console.warn('=====> 全局config可用配置如下：\n', config);
}

export default config;
